import React from 'react';
import '../../scss/circular-counter.scss'
import gsap from 'gsap';
import {LiveMenuState} from './LiveRound'
import { map } from '../../utils/utils';
import App from '../../App';

interface CircularCounterProps{
    currentValue:number;
    total:number;   
    isMobile:boolean;
}
export enum CircularCounterState{
    normal,
    low
}

class CircularCounter extends React.Component <CircularCounterProps>{


    state = {circularCounterState:CircularCounterState.normal}

    mainDiv = React.createRef<HTMLDivElement>();
    myCanvas = React.createRef<HTMLCanvasElement>();
    originalBottomDistance = this.props.isMobile ? 65 : 58;
    lowerBottomDistance = this.props.isMobile ? 83 : 58;

    componentDidMount = ()=>{

        this.setCircularCounterState(CircularCounterState.normal , 0)
    }

    setCircularCounterState = (circularCounterState:CircularCounterState , time = 0.3)=>{

        this.setState({circularCounterState});

        gsap.to(this.mainDiv.current, {
            top:circularCounterState === CircularCounterState.low ?  `${this.lowerBottomDistance}%` : `${this.originalBottomDistance}%`,
            duration: time
        })

    }

    lowerContent = (liveMenuState : LiveMenuState , time : number = 0.5)=>{

        let top = this.state.circularCounterState === CircularCounterState.low ?  this.lowerBottomDistance : this.originalBottomDistance;

        if(liveMenuState === LiveMenuState.open)
            top += 20;

        gsap.to(this.mainDiv.current, {
            top:`${top}%`,
            duration: time
        })
    }

    getAngle = ()=>{
        return map(this.props.currentValue , 0,this.props.total , 290,440); 
    }

    render(){

        const radius = 25;
        const pos = 50;
        return (
            <div ref={this.mainDiv} className="circular-counter">
                 <svg version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                xmlnsXlink="http://www.w3.org/1999/xlink" 
                viewBox="0 0 100 100">
                    <circle cx={pos} cy={pos} r={radius} fill={App.getPropertyFromStyle('--pool-size-background')}></circle>
                    <circle cx={pos} cy={pos} r={radius} fill="none" strokeWidth="5" stroke={App.getPropertyFromStyle('--circle-counter-background-color')} strokeLinecap="round"></circle>
                    <circle cx={pos} cy={pos} r={radius} fill="none" strokeWidth="5" stroke={App.getPropertyFromStyle('--circle-counter-color')} transform="rotate(270 , 50 , 50)" strokeLinecap="round"  strokeDashoffset={`${this.getAngle()}`} strokeDasharray={`440`}></circle>
                    <text className='svg-text' x={pos} y={pos}>{Math.round(this.props.currentValue >= 0 ? this.props.currentValue : 0).toString()}</text>
                </svg>
            </div>
        )
    }
    
}

export default CircularCounter;